import React from "react";

export function IconTypeCourse({type, classname}) {
   switch (type) {
      case 1: // esencial
         return <img src={require("../assets/icons/esencial.png")} className={`${classname} iconDot`} alt="dot" />;
      case 2: // prime
         return <img src={require("../assets/icons/certified.png")} className={`${classname} iconDot`} alt="dot" />;
      case 3: // programa eblem
         return <img src={require("../assets/icons/diamon_circle.png")} className={`${classname} iconDot`} alt="dot" />;
      case 5: // prime
         return <img src={require("../assets/icons/certified.png")} className={`${classname} iconDot`} alt="dot" />;
      case "Facilitators": // facilitados
         return <img src={require("../assets/icons/masterclass_icon_home.png")} className={`${classname} iconDot`} alt="dot" />;
      case "Testimonials": // experience
         return <img src={require("../assets/icons/happy.png")} className={`${classname} iconDot`} alt="dot" />;
      case "Enterprise": // experience
         return <img src={require("../assets/icons/bottles.png")} className={`${classname} iconDot`} alt="dot" />;
      case "DomeqAcademy": // DomeqAcademy
         return null;
      default:
         return null;
   }
}

IconTypeCourse.defaultProps = {
   classname: "icon",
};
